module.exports = __webpack_public_path__ + "img/cym-icon-white.6b4b9c96.svg";